import { AppState } from '@nxsys/store';
import { employeeActions } from '@nxsys/store/slices/employee/reducer/employeeSlice';
import { GetEmployeeListParams } from '@nxsys/store/slices/employee/types';
import { useDispatch, useSelector } from 'react-redux';
import BaseEmployeeListing from '.';
import { agencyAction } from '@nxsys/store/slices/agency/reducer/agencySlice';

const AdminEmployeeListing: React.FC = () => {
  const dispatch = useDispatch();

  const { employeeList } = useSelector(
    (state: AppState) => state.employeeStore,
  );

  const handleFetchData = (params: GetEmployeeListParams) => {
    const newParams = {
      ...params,
    };

    dispatch(employeeActions.getEmployeeList(newParams));
  };

  return (
    <BaseEmployeeListing
      employeeList={employeeList}
      handleFetchData={handleFetchData}
    />
  );
};

const AgencyEmployeeListing: React.FC = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: AppState) => state.appStore);

  const { agencyEmployeeList } = useSelector(
    (state: AppState) => state.agencyStore,
  );

  const handleFetchData = (params: GetEmployeeListParams) => {
    const newParams = {
      ...params,
    };

    if (!user?.agencyId?.id) {
      return;
    }

    dispatch(
      agencyAction.getAgencyEmployeeList({
        id: user?.agencyId?.id,
        ...newParams,
      }),
    );
  };

  return (
    <BaseEmployeeListing
      employeeList={agencyEmployeeList}
      handleFetchData={handleFetchData}
    />
  );
};

const EmployeeListing: React.FC = () => {
  const { isAgency } = useSelector((state: AppState) => state.appStore);

  if (isAgency) {
    return <AgencyEmployeeListing />;
  }

  return <AdminEmployeeListing />;
};

export default EmployeeListing;
